export const createSlug = (title: string) => {
	if (!title) return

	// Remove diacritics from Vietnamese characters
	const removeDiacritics = (str) => {
		return str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
	}

	return removeDiacritics(title)
		.toLowerCase() // Convert to lowercase
		.replace(/[^\w\s-]/g, '') // Remove special characters except hyphens and spaces
		.replace(/\s+/g, '-') // Replace spaces with hyphens
		.trim() // Remove any trailing whitespace
}
